import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

export interface VerifyReservationCodePayload {
  otpCode: string;
  reservationId: string;
  clubId: string;
}

const verifyReservationCode = (client: AxiosInstance) => async (payload: VerifyReservationCodePayload) => {
  return (
    await client.post<{ message: string; data: VerifyReservationCodePayload }>(
      API_ROUTES.VERIFY_RESERVATION_OTP,
      payload,
    )
  ).data;
};

export const reservationLedgerMutations = {
  verifyReservationCode,
};
